export default "__VITE_ASSET__333313b0__"